import server, { get, post } from 'src/utils/request';
import SparkMD5 from 'spark-md5';
/*
* 项目新接口api文件
*/
/* ============1、公共接口============== */
/**
 * 1.1 发送短信验证码
 * @param data
 */
export function sendVerifyCode(data) {
  let url = '/sms/sendVerifyCode';
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}
/**
 * 1.2 文件上传
 * @param data
 */
export function upload(e, type) {
  return new Promise(function (resolve, reject) {
    fileToMd5(e.file).then((fileMd5) => {
      var partFile = e.file;
      if (type) {
        var fileType = type;
        uploadFile({ fileMd5, partFile, fileType }).then(function (res) {
          resolve(res.data);
        }).catch(err => {
          reject(err);
        })
      } else {
        uploadFile({ fileMd5, partFile }).then(function (res) {
          resolve(res.data);
        }).catch(err => {
          reject(err);
        })
      }

    });



  })
}
function uploadFile(data) {
  let url = '/file/upload';
  return server({
    method: 'post',
    url,
    data,
    mode: 'NEW_BASE_URL',
    transformRequest: [function (data) {
      var formData = new FormData();
      for (let i in data) {
        formData.append(i, data[i]);
      }
      return formData;
    }]
  })
}
function fileToMd5(file) {
  var blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
    chunkSize = 2097152,                             // Read in chunks of 2MB
    chunks = Math.ceil(file.size / chunkSize),
    currentChunk = 0,
    spark = new SparkMD5.ArrayBuffer(),
    fileReader = new FileReader();
  fileReader.onerror = function () { };

  function loadNext() {
    var start = currentChunk * chunkSize,
      end = ((start + chunkSize) >= file.size) ? file.size : start + chunkSize;

    fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
  }
  loadNext();
  return new Promise((resolve, reject) => {
    fileReader.onload = function (e) {
      spark.append(e.target.result);                   // Append array buffer
      currentChunk++;
      if (currentChunk < chunks) {
        loadNext();
      } else {
        var hash = spark.end();
        resolve(hash)
      }
    };
  })

}
/**
 * 1.3 验证文件是否存在
 * @param data
 */
export function valid(data) {
  let url = '/file/valid';
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}
/**
 * 1.4 验证文件是否存在
 * @param data
 */
export function download(data) {
  let url = '/file/download';
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}
/**
 * 1.6 文件下载
 * @param data
 */
export function fileDownloadByPath(data) {
  let url = '/file/downloadByPath';
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}
/* ============2、登录管理============== */
/**
 * 2.1 用户登录
 * @param data
 */
export function loginNew(data) {
  let url = '/user/login';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 2.2 退出登录
 * @param data
 */
export function logoutNew(data) {
  let url = '/user/logout';
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}
/**
 * 2.3 忘记密码
 * @param data
 */
export function changeSecretkey(data) {
  let url = '/user/change_secretkey';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 2.3 修改密码
 * @param data
 */
export function updateSecretkey(data) {
  let url = '/user/changePassword';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/* ============3、用户注册============== */
/**
 * 3.1 验证手机号码是否已注册
 * @param data
 */
export function signValidate(data) {
  let url = '/user/sign_validate';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.2 注册
 * @param data
 */
export function signin(data) {
  let url = '/user/signin';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
export function getWxUrl(data) {
  let url = 'user/getWxUrl';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}

/**
 * 3.3 身份证OCR
 * @param data
 */
export function verifyCard(data) {
  let url = '/user/verify_card';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.4 人脸识别 - token
 * @param data
 */
export function verifyVideoGettoken(data) {
  let url = '/user/verify_video_gettoken';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.5 人脸识别
 * @param data
 */
export function validateVideo(data) {
  let url = '/user/validate_video';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.6 企业认证OCR，工商信息核对
 * @param data
 */
export function enterpriseVerify(data) {
  let url = '/user/business/license/ocr';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.7 工商信息核对(点击核对按钮)
 * @param data
 */
export function businessChecking(data) {
  let url = '/user/business/information/checking';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.8 更新认证状态
 * @param data
 */
export function userUpload(data) {
  let url = '/user/update/auth/status';
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}
/**
 * 3.9 查询实名认证信息
 * @param data
 */
export function getRealauth(data) {
  let url = '/user/get/realauth';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.9.2 查询实名认证状态信息
 * @param data
 */
export function getRealAuthStatus(data) {
  let url = '/user/get/auth/status';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.10 修改个人信息
 * @param data
 */
export function editAccount(data) {
  let url = '/user/edit_account';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.11 制作用户CA印章
 * @param data
 */
export function userMakeSeal(data) {
  let url = '/user/makeSeal';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 3.12  OCR验证证件号
 * @param data
 */
export function checkIdentNo(data) {
  let url = `/user/checkIdentNo`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/* ============4、立案申请============== */
/**
 * 4.1 提交立案申请
 * @param data
 */
export function applyCase(data) {
  let url = '/caseInfo/arbApply';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/* ============5、立案申请============== */
/**
 * 5.1 提交立案申请
 * @param data
 */
export function applyCaseList(data) {
  let url = '/caseInfo/myCase';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 5.2 线下案件详情
 * @param data
 */
export function caseInfoCaseDetail(data) {
  let url = '/caseInfo/caseDetail';
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}

/********** 6. 常用代理人管理 ********/
/**
 * 6.2 添加我的代理人
 *
 * */
export function agentAdd(data) {
  let url = `/agent/add`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 6.3 我的代理人列表
 *
 * */
export function agentList(data) {
  let url = `/agent/list`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 6.4 删除代理人
 *
 * */
export function agentDelete(data) {
  let url = `/agent/delete`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 * 6.5 我的被代理人列表
 *
 * */
export function beAgents(data) {
  let url = `/agent/beAgents`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 *  添加留言
 *
 * */
export function addLeaveMessage(data) {
  let url = `/msg/addLeaveMessage`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 *  留言板
 *
 * */
export function myLeaveMessages(data) {
  let url = `/msg/myLeaveMessages`;
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}
/**
 *  人脸识别
 *
 * */
// export function videoMsg(data) {
//   let url = `/user/inquire_video`;
//   let mode = 'NEW_BASE_URL';
//   return get(url, data, mode)
// }
export function videoMsg(data) {
  let url = `user/wxInquire`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}
/**
 *  站内信消息列表
 * @param data
 */
export function readList(data) {
  let url = `/msg/myPlatformMessages`;
  let mode = 'NEW_BASE_URL';
  return get(url, data, mode)
}


/**
 *  站内信消息 （标记已读）
 * @param data
 */
export function read(data) {
  let url = `/msg/readPlatformMessage`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
  // return server({
  //   url: '/msg/readPlatformMessage',
  //   method: 'get',
  //   params
  // })
}
/**
 *  添加证据
 *
 * */
export function addEvidence(data) {
  let url = `/caseInfo/supplyEvidence`;
  let mode = 'NEW_BASE_URL';
  return post(url, data, mode)
}


// WEBPACK FOOTER //
// ./src/api/project_api.js